import { call, put, takeEvery, fork, all } from 'redux-saga/effects';
import axios from 'axios';



function * cloneDocumentAsync(data){
  try{
     let url='/api/documents/clone/'+data.id;
     const api = yield call([axios, axios.post], url)
     yield put({type:'REQUEST_CLONE_DOCUMENT_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * deleteDocumentAsync(data){
  try{
     let url='/api/documents/'+data.id;
     const api = yield call([axios, axios.delete], url)
     yield put({type:'REQUEST_DELETE_DOCUMENT_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * getDocumentAsync(data){
  try{
     let url='/api/documents/'+data.id; //if(data.with_trashed==true){url=url+'?with_trashed=true';}
     const api = yield call([axios, axios.get], url)
     yield put({type:'REQUEST_GET_DOCUMENT_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * getDocumentInstanceAsync(data){
  try{
     let url='/api/documentInstances/'+data.id;
     const api = yield call([axios, axios.get], url)
     yield put({type:'REQUEST_GET_DOCUMENT_INSTANCE_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * indexDocumentsAsync(data){
  try{
     const api = yield call([axios, axios.get], '/api/documents')
     yield put({type:'REQUEST_INDEX_DOCUMENTS_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function * createDocumentAsync(data){
  try{
    const api = yield call([axios, axios.post], '/api/documents', data.payload)
    yield put({type:'REQUEST_CREATE_DOCUMENT_SUCCESS', val:api.data});
    yield put({type:'REQUEST_FORM_COMPLETED', val:true});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_FORM_ERROR', val:error.response})
  }
}

function * updateDocumentAsync(data){
  try{
    const api = yield call([axios, axios.post], '/api/documents/'+data.id, data.payload)
    yield put({type:'REQUEST_UPDATE_DOCUMENT_SUCCESS', val:api.data});
    yield put({type:'REQUEST_FORM_COMPLETED', val:true});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_FORM_ERROR', val:error.response})
  }
}



function* Get_document_instance(){yield takeEvery('REQUEST_GET_DOCUMENT_INSTANCE', getDocumentInstanceAsync);}

function* Get_document(){   yield takeEvery('REQUEST_GET_DOCUMENT', getDocumentAsync);}
function* Delete_document(){   yield takeEvery('REQUEST_DELETE_DOCUMENT', deleteDocumentAsync);}
function* Index_documents(){yield takeEvery('REQUEST_INDEX_DOCUMENTS', indexDocumentsAsync);}
function* Create_document(){yield takeEvery('REQUEST_CREATE_DOCUMENT', createDocumentAsync);}
function* Update_document(){yield takeEvery('REQUEST_UPDATE_DOCUMENT', updateDocumentAsync);}
function* Clone_document(){yield takeEvery('REQUEST_CLONE_DOCUMENT', cloneDocumentAsync);}


function * deleteChecklistAsync(data){
  try{
     let url='/api/checklists/'+data.id;
     const api = yield call([axios, axios.delete], url)
     yield put({type:'REQUEST_DELETE_CHECKLIST_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * getChecklistAsync(data){
  try{
     let url='/api/checklists/'+data.id; //if(data.with_trashed==true){url=url+'?with_trashed=true';}
     const api = yield call([axios, axios.get], url)
     yield put({type:'REQUEST_GET_CHECKLIST_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function * indexChecklistsAsync(data){
  try{
     const api = yield call([axios, axios.get], '/api/checklists')
     yield put({type:'REQUEST_INDEX_CHECKLISTS_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function * createChecklistAsync(data){
  try{
    const api = yield call([axios, axios.post], '/api/checklists', data.payload)
    yield put({type:'REQUEST_CREATE_CHECKLIST_SUCCESS', val:api.data});
    yield put({type:'REQUEST_FORM_COMPLETED', val:true});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_FORM_ERROR', val:error.response})
  }
}

function * updateChecklistAsync(data){
  try{
    const api = yield call([axios, axios.put], '/api/checklists/'+data.id, data.payload)
    yield put({type:'REQUEST_UPDATE_CHECKLIST_SUCCESS', val:api.data});
    yield put({type:'REQUEST_FORM_COMPLETED', val:true});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_FORM_ERROR', val:error.response})
  }
}

function * cloneChecklistAsync(data){
  try{
    const api = yield call([axios, axios.post], '/api/checklists/clone/'+data.id)
    yield put({type:'REQUEST_CLONE_CHECKLIST_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_FORM_ERROR', val:error.response})
  }
}

//function * updateSalesCoachAsync(data){
//  try{
//    const api = yield call([axios, axios.put], '/api/sales_coach', data.data)
//    yield put({type:'REQUEST_UPDATE_SALES_COACH_SUCCESS', val:api.data});
//    yield put({type:'REQUEST_FORM_COMPLETED', val:true});
//  }catch(error){console.log(error, 'ERROR');
//    yield put({type:'REQUEST_FORM_ERROR', val:error.response})
//  }
//}

//function * getSalesCoachAsync(data){
//  try{
//     const api = yield call([axios, axios.get], '/api/sales_coach', data.data)
//     yield put({type:'REQUEST_GET_SALES_COACH_SUCCESS', val:api.data});
//  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
//}

function* Get_checklist(){   yield takeEvery('REQUEST_GET_CHECKLIST', getChecklistAsync);}
function* Delete_checklist(){   yield takeEvery('REQUEST_DELETE_CHECKLIST', deleteChecklistAsync);}
function* Index_checklists(){yield takeEvery('REQUEST_INDEX_CHECKLISTS', indexChecklistsAsync);}
function* Create_checklist(){yield takeEvery('REQUEST_CREATE_CHECKLIST', createChecklistAsync);}
function* Update_checklist(){yield takeEvery('REQUEST_UPDATE_CHECKLIST', updateChecklistAsync);}
function* Clone_checklist(){yield takeEvery('REQUEST_CLONE_CHECKLIST', cloneChecklistAsync);}


//function* Update_sales_coach(){yield takeEvery('REQUEST_UPDATE_SALES_COACH', updateSalesCoachAsync);}
//function* Get_sales_coach(){yield takeEvery('REQUEST_GET_SALES_COACH', getSalesCoachAsync);}

function * deleteQuizzAsync(data){
  try{
     let url='/api/quizzes/'+data.id;
     const api = yield call([axios, axios.delete], url)
     yield put({type:'REQUEST_DELETE_QUIZZ_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * getQuizzAsync(data){
  try{
     let url='/api/quizzes/'+data.id; //if(data.with_trashed==true){url=url+'?with_trashed=true';}
     const api = yield call([axios, axios.get], url)
     yield put({type:'REQUEST_GET_QUIZZ_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function * indexQuizzesAsync(data){
  try{
     const api = yield call([axios, axios.get], '/api/quizzes')
     yield put({type:'REQUEST_INDEX_QUIZZES_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function * createQuizzAsync(data){
  try{
    const api = yield call([axios, axios.post], '/api/quizzes', data.payload)
    yield put({type:'REQUEST_CREATE_QUIZZ_SUCCESS', val:api.data});
    yield put({type:'REQUEST_FORM_COMPLETED', val:true});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_FORM_ERROR', val:error.response})
  }
}

function * updateQuizzAsync(data){
  try{
    const api = yield call([axios, axios.put], '/api/quizzes/'+data.id, data.payload)
    yield put({type:'REQUEST_UPDATE_QUIZZ_SUCCESS', val:api.data});
    yield put({type:'REQUEST_FORM_COMPLETED', val:true});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_FORM_ERROR', val:error.response})
  }
}


function* Get_quizz(){   yield takeEvery('REQUEST_GET_QUIZZ', getQuizzAsync);}
function* Delete_quizz(){   yield takeEvery('REQUEST_DELETE_QUIZZ', deleteQuizzAsync);}
function* Index_quizzes(){yield takeEvery('REQUEST_INDEX_QUIZZES', indexQuizzesAsync);}
function* Create_quizz(){yield takeEvery('REQUEST_CREATE_QUIZZ', createQuizzAsync);}
function* Update_quizz(){yield takeEvery('REQUEST_UPDATE_QUIZZ', updateQuizzAsync);}


function * clickSalesCoachChecklistAsync(data){
  try{
    const api = yield call([axios, axios.post], '/api/sales_coach/click_checklist', data.payload)

    yield put({type:'REQUEST_UPDATE_DEAL_SUCCESS', val:api.data.deal});
    yield put({type:'UPDATE_SCORECARD_UPDATE_DEAL', val:api.data.deal});
    yield put({type:'REQUEST_TIMELINE_ITEM_CHECKLIST_SUCCESS', val:api.data});
    yield put({type:'REQUEST_SALES_COACH_REFRESH'});
    for(let tid of api.data.delete_timeline_items){
      yield(put({type:'REQUEST_TIMELINE_ITEM_DELETE_SUCCESS', val:tid}));
    }
    if(api.data.force_open_task!=undefined){
      yield put({type:'REQUEST_DOUBLE_SELECTED_TIMELINE_ITEM', val:api.data.force_open_task.id, val_type:'complete_task', timeline_item:api.data.force_open_task});
    }
   }catch(error){console.log(error, 'ERROR');
     if(error.response!=undefined && error.response.data!=undefined && error.response.data.error!=undefined){yield put({type:'SET_SNACKBAR', val:{open:true, type:'error', message:error.response.data.error}});}
     else{yield put({type:'REQUEST_ERROR', val:error.response})};
     yield put({type:'REQUEST_CLICK_SALES_COACH_CHECKLIST_FAIL'});
   }
}

function * completeQuizzQuestionAsync(data){
  try{
    const api = yield call([axios, axios.post], '/api/sales_coach/complete_quizz_question', data.payload)
    yield put({type:'REQUEST_UPDATE_DEAL_SUCCESS', val:api.data.deal});
    if(api.data.quizz!=null && api.data.quizz!=undefined){
      yield put({type:'REQUEST_UPDATE_QUIZZ_SUCCESS', val:api.data.quizz});
    }
    yield put({type:'REQUEST_SALES_COACH_REFRESH'});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function* Click_sales_coach_checklist(){yield takeEvery('REQUEST_CLICK_SALES_COACH_CHECKLIST', clickSalesCoachChecklistAsync);}
function* Complete_quizz_question(){yield takeEvery('REQUEST_QUIZZ_QUESTION_COMPLETED', completeQuizzQuestionAsync);}


function * saveDefaultAsync(data){
  try{
    const api = yield call([axios, axios.put], '/api/defaults', data.payload)
    window.location.href='/defaults';
    yield put({type:'REQUEST_SAVE_DEFAULT_SUCCESS', val:api.data});
    yield put({type:'REQUEST_FORM_COMPLETED', val:true});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_FORM_ERROR', val:error.response})
  }
}

function * deleteDefaultAsync(data){
  try{
    const api = yield call([axios, axios.delete], '/api/defaults/'+data.id)
    yield put({type:'REQUEST_DELETE_DEFAULT_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_ERROR', val:error.response})
  }
}

function * indexDefaultsAsync(data){
  try{
     const api = yield call([axios, axios.get], '/api/defaults')
     yield put({type:'REQUEST_INDEX_DEFAULTS_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function* Delete_default(){yield takeEvery('REQUEST_DELETE_DEFAULT', deleteDefaultAsync);}
function* Save_default(){yield takeEvery('REQUEST_SAVE_DEFAULT', saveDefaultAsync);}
function* Index_defaults(){yield takeEvery('REQUEST_INDEX_DEFAULTS', indexDefaultsAsync);}

export default function* Root_sales_coach(){
  yield all([
    fork(Save_default),
    fork(Index_defaults),
    fork(Delete_default),

    fork(Get_document_instance),
    fork(Get_document),
    fork(Delete_document),
    fork(Index_documents),
    fork(Create_document),
    fork(Update_document),
    fork(Clone_document),

    fork(Get_checklist),
    fork(Delete_checklist),
    fork(Index_checklists),
    fork(Create_checklist),
    fork(Update_checklist),
    fork(Clone_checklist),

    fork(Get_quizz),
    fork(Delete_quizz),
    fork(Index_quizzes),
    fork(Create_quizz),
    fork(Update_quizz),

    //fork(Get_sales_coach),
    //fork(Update_sales_coach),

    fork(Click_sales_coach_checklist),
    fork(Complete_quizz_question)
  ])}
